module.exports = __webpack_public_path__ + "img/photo_250010783_1.cd4dd7e0.jpg";